import clsx from "clsx";
import type { PropsWithChildren } from "react";

const columnNums = {
	"12": "md:grid-cols-3 lg:grid-cols-6 xl:grid-cols-12",
  "11": "md:grid-cols-3 lg:grid-cols-6 xl:grid-cols-11",
  "10": "md:grid-cols-3 lg:grid-cols-6 xl:grid-cols-10",
  "9": "md:grid-cols-3 lg:grid-cols-9",
  "8": "grid-cols-2 md:grid-cols-3 lg:grid-cols-8",
  "7": "md:grid-cols-3 lg:grid-cols-7",
  "6": "grid-cols-2 md:grid-cols-3 lg:grid-cols-6",
  "5": "sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5",
  "4": "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
  "4-md": "md:grid-cols-2 lg:grid-cols-4",
  "4-sm": "sm:grid-cols-2 lg:grid-cols-4",
  "3": "md:grid-cols-2 lg:grid-cols-3",
  "3-md": "grid-cols-1 md:grid-cols-3",
  "3-sm": "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
  "2": "grid-cols-1 md:grid-cols-2",
  "2-sm": "md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2",
  "1": "grid-cols-1",
};

export type ColumnNums = keyof typeof columnNums;

interface Props extends PropsWithChildren {
  columnNum?: string | number;
  className?: string;
  gap?: string;
}

export default function GridColumn({className="", columnNum="4", gap ='gap-6', children, ...props}:Props) {
  return (
  <div className={clsx("grid", Object.hasOwn(columnNums, columnNum) ? columnNums[columnNum as ColumnNums] : columnNum, gap, className)} {...props}>
    {children}
  </div>
  );
}